import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import {
  RangeSliderProps,
  rangeSliderNoList,
} from '../../classes/custom-range-slider';
import { Subject } from 'rxjs';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';

@Component({
  selector: 'reusable-form',
  templateUrl: './reusable-form.component.html',
  styleUrls: ['./reusable-form.component.css'],
})
export class ReusableFormComponent implements OnInit {
  @Input() sliderObject: Record<string, any>;

  // these two are for optional use
  @Input() showSubmit: boolean = false;
  @Input() submitText: string = 'Submit';
  //

  @Output() sliderUpdate = new EventEmitter<Object>();

  form = new FormGroup({});

  model: any = {};

  options: FormlyFormOptions = {
    fieldChanges: new Subject<FormlyValueChangeEvent>(),
  };

  /*
   add extra props if needed, this is just for future ref,
   we can directly add extra props in OnInit, like we do for formName below.
  */
  extraProps = { prefix: '£' };

  processedSliderObject = {};

  fields: FormlyFieldConfig[];

  ngOnInit(): void {
    this.createModel();
    this.buildSliderConfig();
    this.subscribeToFieldChanges();
  }

  createModel(): void {
    // TODO: remove the default model
    this.model = {
      rangeSliderNoList: this.sliderObject.model || rangeSliderNoList,
    };
  }

  buildSliderConfig(): void {
    this.processedSliderObject = {
      ...rangeSliderNoList,
      props: { ...this.getSliderPropsForModel() },
    };
    this.fields = [{ ...this.processedSliderObject }];
  }

  getSliderPropsForModel(): RangeSliderProps {
    return {
      ...rangeSliderNoList.props,
      ...this.extraProps,
      formName: this.sliderObject.formName,
      label: this.sliderObject.label,
      min: this.sliderObject.min,
      max: this.sliderObject.max,
      from: this.sliderObject.from,
      to: this.sliderObject.to,
      postfix: this.sliderObject.postfix,
      max_postfix: this.sliderObject.max_postfix,
      prefix: this.sliderObject.prefix,
      step: this.sliderObject.step,
      values: this.sliderObject.values,
    };
  }

  subscribeToFieldChanges(): void {
    this.options.fieldChanges.subscribe((event: FormlyValueChangeEvent) => {
      const { label } = event.field.props;
      const { from: lower, to: upper } = event.value;
      this.sliderUpdate.emit({ label, lower, upper });
    });
  }

  updateFormFields(): void {
    this.buildSliderConfig();
  }

  resetForm(fromOrTo?: 'from' | 'to'): void {
    if (fromOrTo === 'from' || fromOrTo === 'to') {
      this.sliderObject[fromOrTo] = null;
    } else {
      this.sliderObject.from = null;
      this.sliderObject.to = null;
    }

    this.updateFormFields();
    this.form.reset();
  }
}
